import React from 'react';

const MessageToast = ({ message }) => {
    const sender = message?.senderUser;
    const senderName = sender?.fullName || 'Someone';
    const senderId = sender?.id || message?.sender;
    const chatUrl = senderId ? `/chat?userId=${senderId}` : '/chat';

    const handleSenderClick = (e) => {
        e.preventDefault();
        window.location.href = chatUrl;
    };

    return (
        <div className="d-flex flex-wrap align-items-center">
            <a
                href={chatUrl}
                onClick={handleSenderClick}
                className="text-primary text-decoration-underline fw-bold me-1"
                style={{ cursor: 'pointer' }}
            >
                {senderName}
            </a>
            <span className="me-1">sent a message:</span>
            <span>{message?.message || 'New message received'}</span>
        </div>
    );
};

export default MessageToast;
